import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subject, combineLatest, map, takeUntil } from 'rxjs';
import { Utility, breadcrumbItem } from 'src/app/core/common';
import { IrtwadModel, RtwadSearchCriteria, RtwadSearchResult, RtwadService } from 'src/app/services/rtwad.service';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
	selector: 'app-rtwad-list',
	templateUrl: './rtwad-list.component.html',
	styleUrls: ['./rtwad-list.component.css'],
})
export class RtwadListComponent implements OnInit,OnDestroy {
	Utility = Utility;
	searchResult: RtwadSearchResult;
	searchParams: { q?: string; l?: string };
	from = 0;
	limit = 20;
	paidCount = 5;
	criteria: RtwadSearchCriteria = new RtwadSearchCriteria();
	breadcrumbData: breadcrumbItem[];
	title: string;
	dataLoadedFirstTime = false;

	constructor(private rtwadService: RtwadService, private sharedService: SharedService,
		private route: ActivatedRoute,
		private spinner: SpinnerService) {
	}

	private unsubscribe$ = new Subject<void>();
	ngOnDestroy() {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();

	}

	ngOnInit(): void {
		this.dataLoadedFirstTime = false;
		combineLatest([this.route.params, this.route.queryParams]).pipe(
			map(_ => { return { ..._[0], ..._[1] } }),
			takeUntil(this.unsubscribe$),
		).subscribe(async (params) => await this.load(params));
	}



	async load(params: Params) {

		this.spinner.show('rtwad-list');
		this.searchParams = { ...this.searchParams, ...params };
		this.criteria = new RtwadSearchCriteria({
			Keyword: this.searchParams.q || undefined,
			State: this.searchParams.l ? this.searchParams.l.split('،')[0] : undefined,
			City: this.searchParams.l?.split('،').length > 1 ? this.searchParams.l.split('،')[1] : undefined,
		});

		this.from = 0;
		await this.getSearchResults();

		this.spinner.hide('rtwad-list');

		this.setSeo();
		this.dataLoadedFirstTime = true;
	}

	private async getSearchResults(append = false) {
		const result = await this.rtwadService.search(this.criteria, this.from, this.limit, this.paidCount);
		const list = result.PaidList?.length > 0 ? this.combineLists(result.PaidList, result.List) : result.List;
		this.searchResult = {
			...result,
			List: append ? [...this.searchResult.List, ...list] : list
		};
	}

	combineLists(paidList: IrtwadModel[], freeList: IrtwadModel[]) {
		// combine with this pattern: 3 paid, 10 free, 2 paid, rest of free
		return [...(paidList.slice(0, 3)), ...(freeList.slice(0, 10)), ...(paidList.slice(3, 5)), ...(freeList.slice(10))];
	}

	setSeo() {
		this.title = `آگهی‌های آماده به کار`;
		let description = `آگهی‌های آماده به کار، جویای کار، تامین نیرو، تامین خدمات `;

		if (this.criteria.Keyword){
			this.title += `	${this.criteria.Keyword}`;
			description += `	${this.criteria.Keyword}`;
		}

		if (this.criteria.State){
			this.title += ` در ${Utility.locationString(this.criteria.State, this.criteria.City)}`;
			description += ` در ${Utility.locationString(this.criteria.State, this.criteria.City)}`;
		}



		this.sharedService.setTitle(this.title);
		this.sharedService.setDescriptionMeta(description);
		this.sharedService.setKeywordsMeta('آماده به کار', this.criteria.Keyword, this.criteria.State, this.criteria.City);
    this.breadcrumbData = this.rtwadService.getBreadcrumb(this.searchParams);
	}

	async loadMore() {
		this.spinner.show('rtwad-list-more');
		this.from += this.limit;
		await this.getSearchResults(true);
		this.spinner.hide('rtwad-list-more');
	}



}
